/* Each choice submits both native codes. Shopify controls pricing and redirects. */
document.addEventListener('submit', event => {
  const form = event.target.closest('.offline-localization__form');
  if (!form) return;
  // Shopify's form tag supplies return_to; update it without adding a duplicate.
  const target = form.querySelector('input[name="return_to"]');
  if (target) target.value = location.pathname + location.search + location.hash;
});
document.addEventListener('click', event => {
  document.querySelectorAll('[data-offline-localization][open]').forEach(selector => {
    if (!selector.contains(event.target)) selector.open = false;
  });
});
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  const selector = event.target.closest('[data-offline-localization][open]');
  if (!selector) return;
  selector.open = false;
  selector.querySelector('summary').focus();
  event.preventDefault();
  event.stopPropagation();
}, true);

// Keep native browser form validation in the selected storefront language.
document.addEventListener('invalid', event => {
  const input = event.target;
  if (!input.closest('.contact-form')) return;
  const hint = input.closest('[data-field]')?.querySelector('[data-msg]');
  if (hint) input.setCustomValidity(input.validity.tooLong ? hint.dataset.msgLong : hint.dataset.msg);
}, true);
document.addEventListener('input', event => {
  if (event.target.closest('.contact-form') && event.target.setCustomValidity) event.target.setCustomValidity('');
});
